import type { ParkAndRideFacility, ParkingFacility, Station } from '@/modules/api/backend';
import { StationType, Subject } from '@/modules/api/backend';
import { FeatureType } from '@/types/FeatureType';
import { MapLayer } from '@/types/MapLayer';
import type { PickupParkingFacilityFeature } from '@/types/PickupParkingFacilityFeature';

export function getMapLayer(
  entity: ParkingFacility | ParkAndRideFacility | Station | PickupParkingFacilityFeature,
): MapLayer {
  if ('__caslSubjectType__' in entity) {
    // eslint-disable-next-line no-underscore-dangle
    if (entity.__caslSubjectType__ === Subject.ParkingFacility) {
      return MapLayer.PARKING_FACILITY;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (entity.__caslSubjectType__ === Subject.ParkAndRideFacility) {
      return MapLayer.PARK_AND_RIDE_FACILITY;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (entity.__caslSubjectType__ === Subject.Station) {
      return { [StationType.BUS]: MapLayer.BUS_STATION, [StationType.TRAIN]: MapLayer.TRAIN_STATION }[
        (entity as Station).type
      ];
    }
  }

  if ('properties' in entity && entity.properties.featureType === FeatureType.PICKUP_PARKING_FACILITY) {
    return MapLayer.PICKUP_PARKING_FACILITY;
  }

  throw new Error('Unrecognized entity');
}
